import React, { useEffect } from "react";
import { TransportOption } from "../../../models/financing-request/transport-option/TransportOption";
import PersonalTransportOption from "../../../models/financing-request/transport-option/PersonalTransportOption";
import {
  Grid,
  makeStyles,
  createStyles,
  Theme,
  InputAdornment
} from "@material-ui/core";
import TrSelect from "../../shared/controls/TrSelect";
import FinancingRequestStudent from "../../../models/financing-request/FinancingRequestStudent";
import TrSelectData from "../../../models/shared/TrSelectData";
import {
  nameof,
  numberFormat,
  getTooltipForDecimalInput
} from "../../../utilities/utilities";
import TrTextField from "../../shared/controls/TrTextField";
import TrackerName from "../../../models/financing-request/student-data/FinancingRequestStudentDataTrackerName";
import ValidationResult from "../../../hooks/change-tracker/ValidationResult";
import FinancingRequestStudentData from "../../../models/financing-request/student-data/FinancingRequestStudentData";

interface Props {
  index: number;
  transportOption: TransportOption;
  selectedStudents: FinancingRequestStudent[];
  validationResult: ValidationResult;
  onChange: (e: any) => void;
  onSelectChange?: (e: any) => void;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    textField: {
      width: "100%",
      maxWidth: "100%"
    }
  })
);

export default function PersonalTransportItem({
  index,
  transportOption,
  selectedStudents,
  validationResult,
  onChange,
  onSelectChange
}: Props) {
  const classes = useStyles({});
  let personalTransportOption = transportOption as PersonalTransportOption;
  let drivingStudentsIds = new Array<number>();

  if (personalTransportOption.passengers) {
    personalTransportOption.passengers.forEach(passenger => {
      drivingStudentsIds.push(passenger.id);
    });
  }
  let selectedStudentsIds = new Array<number>();
  selectedStudents.forEach(student => {
    selectedStudentsIds.push(student.id);
  });

  function getSelectData() {
    const selectData: TrSelectData<FinancingRequestStudent> = {
      valueProp: "id",
      textProp: "firstName",
      textFunct: (d: FinancingRequestStudent) => d.lastName + " " + d.firstName,
      data: selectedStudents
    };

    return selectData;
  }

  useEffect(() => {
    personalTransportOption = transportOption as PersonalTransportOption;
  }, [transportOption]);

  return (
    <>
      <Grid item lg={3} md={6} sm={12} xs={12}>
        <TrTextField
          required
          label="Udaljenost od kuće do škole"
          name={nameof<typeof personalTransportOption>(
            "mileageFromHomeToSchool"
          )}
          value={personalTransportOption.mileageFromHomeToSchool || ""}
          onChange={onChange}
          className="textField"
          type="number"
          tooltip={getTooltipForDecimalInput()}
          helperText={`Ukupna dnevna kilometraža (kilometri x 4): ${
            personalTransportOption.mileageFromHomeToSchool
              ? numberFormat(
                  personalTransportOption.mileageFromHomeToSchool * 4,
                  "km",
                  4
                )
              : numberFormat(0, "km")
          }`}
          InputProps={{
            endAdornment: <InputAdornment position="end">Km</InputAdornment>
          }}
          error={
            !validationResult.isArrayPropertyWithParrentValid(
              TrackerName.StudentsData,
              index.toString(),
              nameof<FinancingRequestStudentData>("transportOption"),
              nameof<PersonalTransportOption>("mileageFromHomeToSchool")
            )
          }
        />
      </Grid>
      <Grid item lg={3} md={6} sm={12} xs={12}>
        <TrSelect
          multiple
          name={nameof<typeof personalTransportOption>("passengers")}
          className="selectFormControl"
          label="S učenikom se vozi još djece"
          value={drivingStudentsIds}
          selectData={getSelectData()}
          onChange={onSelectChange}
        ></TrSelect>
      </Grid>
      <Grid item lg={3} md={6} sm={12} xs={12}>
        <TrTextField
          label="S učenikom se vozi još djece"
          value={drivingStudentsIds.length}
          className={classes.textField}
          InputProps={{
            readOnly: true
          }}
        />
      </Grid>
      <Grid item lg={3} md={6} sm={12} xs={12}></Grid>
    </>
  );
}
